<template>
	<div class="characteristic-scale">
		<div v-if="title" class="characteristic-scale--title">{{ title }}</div>
		<div class="characteristic-scale--options">
			<div>
				<div
					v-for="(option, i) in options"
					:key="option.key"
					:class="[
						'characteristic-scale--option',
						{
							'characteristic-scale--option-selected': isChecked(option),
							'characteristic-scale--option-first': i === 0,
							'characteristic-scale--option-last': i === (options.length - 1),
						}
					]"
				>
					<div
						class="characteristic-scale--option-select"
						@mouseenter="hoveredOption = option"
						@mouseleave="hoveredOption = undefined"
					>
						<b-form-radio
							v-model="selected"
							:value="option.value"
							:name="name"
							@change="emitChangeEvent"
						/>
					</div>
				</div>
				<div class="characteristic-scale--line">&nbsp;</div>
			</div>
		</div>
		<div v-if="hoveredOption" class="characteristic-scale--label preview">{{ hoveredLabel }}</div>
		<div v-else :class="['characteristic-scale--label', {'choose': selected === undefined}]">{{ label }}</div>
	</div>
</template>

<script>
import {uuid} from "vue-uuid";
import {APPLICATION, get} from "@/helper/characteristic/Label";

// there is a problem with null/undefined in b-form-radio, so we are using a custom string within the component
const NOTHING_VALUE = 'nothing';

export default {

	props: {
		value: {
			type: Object,
			required: false,
		},
		title: {
			type: String,
			required: false,
		},
		characteristicItems: {
			type: Array,
			required: true,
		},
		nothingAllowed: {
			type: Object,
			required: false,
		},
		labelType: {
			type: String,
			required: false,
			default: APPLICATION
		},
		chooseText: {
			type: String,
			required: false,
			default: 'Bitte triff eine Auswahl'
		}
	},

	data ()
	{
		let selected = undefined;

		if (this.value === null)
		{
			selected = NOTHING_VALUE;
		}
		else if (this.value)
		{
			selected = _.find(this.characteristicItems, c => c.id === this.value.id);
		}

		return {
			name: 'characteristic-scale-' + uuid.v4(),
			selected,
			hoveredOption: undefined,
		};
	},

	computed: {
		label ()
		{
			if (this.selected === undefined)
			{
				return this.chooseText;
			}

			if (this.selected === NOTHING_VALUE)
			{
				return this.nothingAllowed.text;
			}

			return get(this.selected, this.labelType);
		},
		hoveredLabel ()
		{
			if (this.hoveredOption.value === NOTHING_VALUE)
			{
				return this.nothingAllowed.text;
			}

			return get(this.hoveredOption.value, this.labelType);
		},
		options ()
		{
			let options = [];

			if (this.nothingAllowed)
			{
				options.push({
					key: 'nothing-allowed',
					value: NOTHING_VALUE,
				});
			}

			_.forEach(this.characteristicItems, characteristic =>
			{
				options.push({
					key: characteristic.id,
					value: characteristic,
				});
			});

			return options;
		}
	},

	methods: {
		select (option)
		{
			this.selected = option.value;

			this.emitChangeEvent();
		},
		isChecked (option)
		{
			if (this.selected === undefined)
			{
				return false;
			}

			if (this.selected === NOTHING_VALUE)
			{
				return option.value === NOTHING_VALUE;
			}

			return option.value !== null && option.value.id === this.selected.id;
		},
		emitChangeEvent ()
		{
			this.$emit('input', this.selected === NOTHING_VALUE ? null : this.selected);
		}
	}
}
</script>
